import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

import { useIsLoggedIn } from '@/lib/auth';
import { useEstablishments } from '@/lib/establishments';
import { TRIAL_DAYS } from '@/seo/site';
import { pluralRu } from '@/utils/format';
import Reveal from '@/components/Reveal';

export default function CTA() {
  const authed = useIsLoggedIn();
  const venues = useEstablishments();

  return (
    <section className="section section-divider">
      <div className="container-site">
        <Reveal>
          <div className="stage px-6 py-14 sm:px-12 sm:py-20 lg:px-20 lg:py-24">
            <div className="grid items-end gap-12 md:grid-cols-12">
              <div className="md:col-span-7">
                <h2 className="text-balance text-[clamp(2.5rem,5vw,4.25rem)] font-medium leading-[1.02] tracking-tightest text-white">
                  Первый заказ через Resstro сегодня вечером
                </h2>
                <p className="mt-6 max-w-lg text-lg leading-relaxed text-white/60">
                  Создайте заведение, загрузите меню и&nbsp;подключите кассу за&nbsp;один вечер.
                  Первые {TRIAL_DAYS}&nbsp;дней бесплатно, без привязки карты.
                  {venues.total > 0 && (
                    <>
                      {' '}
                      <span className="text-white/85">
                        {venues.total}{' '}
                        {pluralRu(venues.total, 'заведение уже так сделало', 'заведения уже так сделали', 'заведений уже так сделали')}.
                      </span>
                    </>
                  )}
                </p>

                <dl className="mt-10 grid grid-cols-1 gap-6 border-t border-white/10 pt-8 sm:grid-cols-3">
                  <Fact value={`${TRIAL_DAYS} дней`} label="полный доступ ко всем функциям" />
                  <Fact value="0 ₽" label="никаких списаний до вашего решения" />
                  <Fact value="На русском" label="поддержка в WhatsApp и по почте" />
                </dl>
              </div>

              <div className="md:col-span-5 md:pl-8">
                <div className="flex flex-col gap-3">
                  <Link to={authed ? '/cabinet' : '/signup'} className="btn-primary justify-between px-7 py-4 text-[15px]">
                    {authed ? 'В личный кабинет' : `Начать ${TRIAL_DAYS} дней бесплатно`}
                    <span className="btn-icon">
                      <ArrowRight size={15} strokeWidth={2} />
                    </span>
                  </Link>
                  <a
                    href="https://wa.me/79894734322"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn justify-between border border-white/15 px-7 py-4 text-[15px] text-white hover:bg-white/[0.06]"
                  >
                    Написать в WhatsApp
                    <ArrowRight size={18} strokeWidth={2} className="text-white/60" />
                  </a>
                </div>
                <p className="mt-4 text-xs text-white/45">resstrosaas@mail.ru · +7 989 473‑43‑22</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

function Fact({ value, label }: { value: string; label: string }) {
  return (
    <div>
      <dd className="num text-[20px] font-medium leading-none text-white">{value}</dd>
      <dt className="mt-2 text-[12.5px] leading-relaxed text-white/55">{label}</dt>
    </div>
  );
}
